module.exports = __webpack_public_path__ + "img/CR06.cf744c67.png";